import { CallApi } from '@signavio/kraken'
import { schema as schemas } from 'normalizr'
import qs from 'qs'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'users'

export const schema = new schemas.Array(new schemas.Entity(collection))

/**
 * endpoint returns all users from all organizations if no organizationId is provided
 */

type RequestParametersType = {
  organizationId: string
  query: string
  offset: number
  pagesize: number
  userIds: string[]
}

export const fetch =
  (callApi: CallApi) =>
  (_: unknown, __: unknown, requestParameters: RequestParametersType) =>
    callApi(
      `${ADMIN_API_BASE}/users${qs.stringify(
        { ...requestParameters },
        { addQueryPrefix: true, arrayFormat: 'brackets' }
      )}`,
      schema
    )
